const WebManagerRouter = [
    {
        path: '',
        redirect: 'organization/cadres_tribune/list'
    },
    {
        path: 'organization/cadres_tribune/list',
        meta: {
            title: '班子介绍',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('@/views/web/manager/page/organization/cadres_tribune/list'),
    },
    {
        path: 'organization/cadres_tribune/add/:id',
        meta: {
            title: '添加班子介绍',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/organization/cadres_tribune/add'),
    },
    {
        path: 'organization/cadres_tribune/show/:id',
        meta: {
            title: '班子介绍',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/organization/cadres_tribune/add'),
    },
    {
        path: 'organization/member/list',
        meta: {
            title: '党员管理',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('@/views/web/manager/page/organization/member/list'),
    },
    {
        path: 'organization/member/add/:id',
        meta: {
            title: '添加党员',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/organization/member/add'),
    },
    {
        path: 'organization/member/show/:id',
        meta: {
            title: '党员',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/organization/member/add'),
    },

    {
        path: 'meeting/member/list',
        meta: {
            title: '党支部党员大会',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('@/views/web/manager/page/meeting/member/list'),
    },
    {
        path: 'meeting/council/list',
        meta: {
            title: '党支部委员会',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('@/views/web/manager/page/meeting/council/list'),
    },
    {
        path: 'meeting/group/list',
        meta: {
            title: '党小组会',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('@/views/web/manager/page/meeting/group/list'),
    },
    {
        path: 'meeting/group/add/:id',
        meta: {
            title: '党小组会',
            needLogin: true, // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/meeting/group/add'),
    },
    {
        path: 'activities/theme/list',
        meta: {
            title: '主题党日活动',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('@/views/web/manager/page/activities/theme/list'),
    },
    {
        path: 'activities/station/list',
        meta: {
            title: '党员示范岗',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('@/views/web/manager/page/activities/station/list'),
    },
    {
        path: 'activities/station/add/:id',
        meta: {
            title: '党员示范岗',
            needLogin: true, // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/activities/station/add'),
    },
    {
        path: 'activities/turnout/list',
        meta: {
            title: '党员责任区',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('@/views/web/manager/page/activities/turnout/list'),
    },
    {
        path: 'activities/turnout/add/:id',
        meta: {
            title: '党员责任区',
            needLogin: true, // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/activities/turnout/add'),
    },
    {
        path: 'standard/duty/list',
        meta: {
            title: '管理制度',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('@/views/web/manager/page/standard/duty/list'),
    },
    {
        path: 'standard/duty/publish/:id',
        meta: {
            title: '添加管理制度',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/standard/duty/publish'),
    },
    {
        path: 'flow/list',
        meta: {
            title: '工作流程',
            needLogin: true, // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/flow/list'),
    },
    {
        path: 'possy/design/list',
        meta: {
            title: '设计模版',
            needLogin: true, // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/possy/design/list'),
    },
    {
        path: 'possy/substance/list',
        meta: {
            title: '内容模版',
            needLogin: true, // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/possy/substance/list'),
    },
    {
        path: 'possy/picture/list',
        meta: {
            title: '现场照片',
            needLogin: true, // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/possy/picture/list'),
    },
    {
        path: 'possy/picture/add/:id',
        meta: {
            title: '添加现场照片',
            needLogin: true, // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/possy/picture/add'),
    },
    {
        path: 'report_material/conclusion/list',
        meta: {
            title: '总结',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('@/views/web/manager/page/report_material/conclusion/list'),
    },
    {
        path: 'report_material/conclusion/add/:id',
        meta: {
            title: '添加总结',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/report_material/conclusion/add'),
    },
    {
        path: 'report_material/plan/list',
        meta: {
            title: '计划',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('@/views/web/manager/page/report_material/plan/list'),
    },
    {
        path: 'report_material/plan/add/:id',
        meta: {
            title: '添加计划',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/report_material/plan/add'),
    },
    {
        path: 'report_material/work/list',
        meta: {
            title: '党支部工作记录',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('@/views/web/manager/page/report_material/work/list'),
    },
    {
        path: 'report_material/work/add/:id',
        meta: {
            title: '添加党支部工作记录',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/report_material/work/add'),
    },
    {
        path: 'report_material/other/list',
        meta: {
            title: '其他',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('@/views/web/manager/page/report_material/other/list'),
    },
    {
        path: 'report_material/other/add/:id',
        meta: {
            title: '添加其他',
            needLogin: true // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/report_material/other/add'),
    },
    {
        path: 'expenditure/list',
        meta: {
            title: '党建经费',
            needLogin: true, // 是否需要登录才能访问
            keepAlive: true
        },
        component: () =>
            import ('@/views/web/manager/page/expenditure/list'),
    },
    {
        path: 'role',
        meta: {
            title: '权限管理',
            needLogin: true, // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/role'),
    },
    {
        path: 'password',
        meta: {
            title: '修改密码',
            needLogin: true, // 是否需要登录才能访问
        },
        component: () =>
            import ('@/views/web/manager/page/password'),
    },
]
export default WebManagerRouter